import { defineStore } from 'pinia';

export interface IClassCreationState {
  hasCreatedClass: boolean;
  navigateAfterCreation: boolean;
  tooltipSeen: boolean;
}

export const useClassCreationStore = defineStore('classCreation', {
  state: (): IClassCreationState => ({
    hasCreatedClass: false,
    navigateAfterCreation: true,
    tooltipSeen: false,
  }),

  actions: {
    setClassCreated() {
      this.hasCreatedClass = true;
    },
    resetClassCreated() {
      this.hasCreatedClass = false;
    },
    setTooltipSeen() {
      this.tooltipSeen = true;
    },
  },
  // no explicit storage: the plugin defaults to localStorage lazily, so importing this module stays safe in node
  persist: {
    key: 'class-creation-store',
  },
});
